export default __webpack_public_path__ + "static/media/ilustracao-calendario-de-sorteios.657070d7.svg";